// classes
import ContentLockModal from "./classes/content-lock-modal";

/**
 * Фабрика: определяет версию модала по серверному флагу и открывает соответствующий экземпляр.
 * @param {object} params
 * @param {String} params.uid - uid софта
 */
const openContentLockModal = async ({ buttonElem, buttonAttributes }) => {
  const { contentLock: contentLockSettings = {} } = window.portal.downloadSettings || {};
  const modal = document.querySelector(".content-lock-modal");

  const elementId = "content-lock-modal";
  const contentLockModal = new ContentLockModal({
    buttonElem,
    buttonAttributes,
    elementId,
    contentLockSettings: {
      ...contentLockSettings,
      browserLink: contentLockSettings.browserLink,
    },
  });
  contentLockModal.open();
  modal?.classList.remove("pre-show");
};

export default openContentLockModal;
